import React from 'react';
import { httpServices } from '../../../services/httpServices.js';
import { CreateProjectWizardComponent } from './CreateProjectWizard.Component.js';
import { CustomProgressBar } from '../../common/CustomProgressBar.js';
import { history } from '../../../helpers/history';

let formValues = {
    name : '',
    description : '',
    chargeCode : '',
    client : '',
    projectManager : '',
    startDate : '',
    endDate : '',
    projectStatus : '1',
    cor : '',
    minTimeInc : '',
    payType : '',
    offsite : false,
    lcr_required: false,
    approvalMethod : 'PM',
    notifyPm : true,
    reqLabourCategory : false,
    inheritResource : false,
    reqClientTimesheet : false,
    inheritReviewers : false,
    dateConfirmationError : '',
    snackbarOpen : false,
    snackbarMsg : '',
    snackbarVarient : '',
    additionalResources : [],
    additionalLcats : [],
    timesheet_location : false,
    prelim_review_flag: false,
    sent_notification : true,
}

const BASE_PATH = process.env.REACT_APP_BASE_PATH; 
const filterValues = {
    status : '1',
    type : '0',
};
export class CreateProjectWizard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInputs : {},
            formValues : formValues,
            showInheritResources : false,
            showInheritReviewers : false,
            errors : {},
            open : false,
            showSubProject : false,
            subProjects : [],
            parentSdate : '',
            parentEdate : '',
            validationPopupOpen : false,
            validationPopupMsg : '',
            popupType : '',
            permission : false,
            permissionErrMsg : '',
            getprojects : true,
            postValidationErr : '',
            taskCount : 0,
            prParent : 0,
            showLoader : true,
            buttonLoader:false,
            nameFormat : 'FIRSTLAST',
            activeStep: 0,
            projectLocations : [],
            projectResources : [],
            otherPermissions : [],
            filterValues : filterValues,
            tasks : [],
            selectedTasks : [],
            selectedRows: [],
            selectedResources: [],
            selectAllResources : false,
            selectAllTasks : false,
            selectedLocations : [],
            selectAllLocations :false,
            contractVehicles : [],
            projectLabels : [],
            selectedLabels : [],
            selectedReviewers : [],
            selectAllLabels : false,
            reportReviewers : [],
            selectAllReviewers : false,
            is_contract : false,
            actionType : '',
            resourceRows : [],
            openAddResource : false,
            users : [],
            rows: [{ id: 1, selectedOption: '', startDate: '', endDate: '' }],
            reviewerRows: [{ id:1 , selectedOption: '', reviewerReportId: ''}],
            newRowId: 2,
            newReviewerRowId : 2,
            errorRow : 0,
            originalResources : [],
            reviewerReportId : ''
        }
        this.handleOnChange = this.handleOnChange.bind(this);
        this.validateRowData = this.validateRowData.bind(this);
        this.handleResourceChange = this.handleResourceChange.bind(this);
        this.clientChange = this.clientChange.bind(this);
        this.handleTreeChange = this.handleTreeChange.bind(this);
        this.parentChange = this.parentChange.bind(this);
        this.save = this.save.bind(this);
        this.createProject = this.createProject.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onAddResourceClose = this.onAddResourceClose.bind(this);
        this.getProjectDetails = this.getProjectDetails.bind(this);
        this.statusChange = this.statusChange.bind(this);
        this.confirmationClose = this.confirmationClose.bind(this);
        this.showTaskEndDateConfirmation = this.showTaskEndDateConfirmation.bind(this);
        this.validateDates = this.validateDates.bind(this);
        this.updateProject = this.updateProject.bind(this);
        this.confirmDatesSubmit = this.confirmDatesSubmit.bind(this);
        this.askEndDate = this.askEndDate.bind(this);
        this.taskEndDateConfirmation = this.taskEndDateConfirmation.bind(this);
        this.handleEndDateConfirmationForClosed = this.handleEndDateConfirmationForClosed.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.snackbarClose = this.snackbarClose.bind(this);
        this.setActiveStep = this.setActiveStep.bind(this);
        this.subProjectStatusChangeConfirmation = this.subProjectStatusChangeConfirmation.bind(this);
        this.handleSelectedRows = this.handleSelectedRows.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.validateFormData = this.validateFormData.bind(this);
        this.onAddResourceClick = this.onAddResourceClick.bind(this);
        this.onAddReviewerClick = this.onAddReviewerClick.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
        this.deleteReviewerRow = this.deleteReviewerRow.bind(this);
        this.handleReviewerChange = this.handleReviewerChange.bind(this);
    }
    componentDidMount = () => {
        let editId = this.props.EditId;
        this.setState({ actionType: this.props.Type });
        if (editId && editId > 0) {
            this.getProjectDetails(editId);
        } else {
            this.getProjectFormInputs();
        }
        let projectParent = this.props.Parent;
        if (projectParent && projectParent > 0) {
            let formValues = this.state.formValues;
            formValues['projectParent'] = projectParent;
            this.setState({ formValues : formValues }, function() {
            this.parentChange();
           });
        }
        if (this.props.Type == "Copy")
        {
            this.getworkLocationsDetails(this.props.EditId);
            this.getListProjectResources(this.props.EditId);
            this.getProjectTasks(this.props.EditId);
            this.getProjectLabels(this.props.EditId);
            this.getReportReviewers(this.props.EditId);
        }
        else if (this.props.Type == "AddSubProject")
        {
            this.getworkLocationsDetails(projectParent);
            this.getProjectLabels(projectParent);
            this.getListProjectResources(projectParent);
            this.getReportReviewers(projectParent);
        }
        
    }
    componentWillUnmount () {
        // Cleaning the mounted component just before leaving.
        formValues = {
            name : '',
            description : '',
            chargeCode : '',
            client : '',
            projectManager : '',
            startDate : '',
            endDate : '',
            projectStatus : '1',
            cor : '',
            minTimeInc : '',
            payType : '',
            offsite : false,
            approvalMethod : 'PM',
            lcr_required : false,
            notifyPm : true,
            reqLabourCategory : false,
            inheritResource : false,
            reqClientTimesheet : false,
            inheritReviewers : false,
            dateConfirmationError : '',
            timesheet_location : false,
            prelim_review_flag : false,
            sent_notification : true,
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.Open !== this.state.open) {
            this.setState({ open: this.props.Open });
        }
    }
    onClose = () => {
        this.props.UpdateParentOnCopySuccess(false);
    }
    handleSelectedRows = (rows) => {
        this.setState({ selectedRows: rows });
    };
    onAddResourceClick = () => {
        this.setState(prevState => ({
            rows: [...prevState.rows, { id: prevState.newRowId, selectedOption: '', startDate: '', endDate: '' }],
            newRowId: prevState.newRowId + 1,
        }));
    }
    onAddReviewerClick = () => {
        this.setState(prevState => ({
            reviewerRows: [...prevState.reviewerRows, { id: prevState.newReviewerRowId, selectedOption: '',reviewerReportId : this.state.selectedReport}],
            newReviewerRowId: prevState.newReviewerRowId + 1,
        }));
    }
    deleteRow = (id) => {
        this.setState(prevState => ({
            rows: prevState.rows.filter(row => row.id !== id),
          }));
    }
    deleteReviewerRow = (id) => {
        this.setState(prevState => ({
            reviewerRows: prevState.reviewerRows.filter(row => row.id !== id),
          }));
    }
    handleCheckboxChange = (evt, id) => {
     let name = evt.target.name;
     if (name === "select_all")
     {
        let selectedResources = this.state.selectedResources;
        let allResources = this.state.projectResources;
        
        if (evt.target.checked) {
            allResources.forEach(function (item) {
                selectedResources.push(item.id);
            })
            this.setState({ selectAllResources: true });
        }
        else{
            selectedResources = [];
            this.setState({ selectAllResources: false });
        }
        this.setState({ selectedResources: selectedResources });
     }
     else if (name === "row_select")
     {
        let selectedResources = this.state.selectedResources;
        if (evt.target.checked) {
            selectedResources.push(id);
        }
        else{
            selectedResources = selectedResources.filter(item => item !== id);
        }
        this.setState({ selectedResources: selectedResources });
     }
     else if (name === "select_all_tasks")
     {
        let selectedTasks = this.state.selectedTasks;
        let allTasks = this.state.tasks;
        
        if (evt.target.checked) {
            allTasks.forEach(function (item) {
                selectedTasks.push(item.task_id);
            })
            this.setState({ selectAllTasks: true });
        }
        else{
            selectedTasks = [];
            this.setState({ selectAllTasks: false });
        }
        this.setState({ selectedTasks: selectedTasks });
     }
     else if (name === "task_row_select")
     {
        let selectedTasks = this.state.selectedTasks;
        if (evt.target.checked) {
            selectedTasks.push(id);
        }
        else{
            selectedTasks = selectedTasks.filter(item => item !== id);
        }
        this.setState({ selectedTasks: selectedTasks });
     }
     else if (name === "select_all_locations")
     {
        let selectedLocations = this.state.selectedLocations;
        let allLocations = this.state.projectLocations;
        
        if (evt.target.checked) {
            allLocations.forEach(function (item) {
                selectedLocations.push(item.id);
            })
            this.setState({ selectAllLocations: true });
        }
        else{
            selectedLocations = [];
            this.setState({ selectAllLocations: false });
        }
        this.setState({ selectedLocations: selectedLocations });
     }
     else if (name === "location_row_select")
     {
        let selectedLocations = this.state.selectedLocations;
        if (evt.target.checked) {
            selectedLocations.push(id);
        }
        else{
            selectedLocations = selectedLocations.filter(item => item !== id);
        }
        this.setState({ selectedLocations: selectedLocations });
     }
     else if (name === "select_all_labels")
     {
        let selectedLabels = this.state.selectedLabels;
        let allLabels = this.state.projectLabels;
        
        if (evt.target.checked) {
            allLabels.forEach(function (item) {
                selectedLabels.push(item.id);
            })
            this.setState({ selectAllLabels: true });
        }
        else{
            selectedLabels = [];
            this.setState({ selectAllLabels: false });
        }
        this.setState({ selectedLabels: selectedLabels });
     }
     else if (name === "label_row_select")
     {
        let selectedLabels = this.state.selectedLabels;
        if (evt.target.checked) {
            selectedLabels.push(id);
        }
        else{
            selectedLabels = selectedLabels.filter(item => item !== id);
        }
        this.setState({ selectedLabels: selectedLabels });
     }
     else if (name === "select_all_reviewers") {
        let selectedReviewers = this.state.selectedReviewers;
        let allReviewers = this.state.reportReviewers;
        if (evt.target.checked) {
            allReviewers.forEach(function (item) {
                selectedReviewers.push(item.id);
            })
            this.setState({ selectAllReviewers: true });
        } else {
            selectedReviewers = [];
            this.setState({ selectAllReviewers: false });
        }
        this.setState({ selectedReviewers: selectedReviewers });
     }
     else if (name === "reviewer_row_select") {
        let selectedReviewers = this.state.selectedReviewers;
        if (evt.target.checked) {
            selectedReviewers.push(id);
        } else{
            selectedReviewers = selectedReviewers.filter(item => item !== id);
        }
        this.setState({ selectedReviewers: selectedReviewers });
     }
    }
    confirmationClose = () => {
        this.setState({
            validationPopupOpen : false,
            validationPopupMsg : '',
            popupType : '',
        });
    }
    handleResourceChange = (evt, id, field) => {
        const { rows } = this.state;
        const updatedRows = rows.map(row => {
            if (row.id === id) {
                return { ...row, [field]: evt.target.value };
            }
            return row;
        });
        this.setState({ rows: updatedRows });
    }
    handleReviewerChange = (evt, id, field) => {
        const { reviewerRows } = this.state;
        const updatedRows = reviewerRows.map(row => {
            if (row.id === id) {
                return { ...row, [field]: evt.target.value, reviewerReportId : this.state.selectedReport };
            }
            return row;
        });
        this.setState({ reviewerRows: updatedRows });
    }
    getProjectTasks = (projectId) => {
        if (projectId) {            
            const data = this.state.filterValues;
            data.project_id = projectId;
            return httpServices
                .post("api/project/getprojecttasks", data)
                .then((response) => {
                    if (response.data && response.data.valid) {               
                        this.setState({
                            tasks : response.data.tasks,
                        });
                    } 
                })
                .catch(function (error) {
                    console.log("Error: " + error);
                });
        }
    }
    getworkLocationsDetails = (projectId) => {
        let apiEndpoint = 'api/project/getProjectWorkLocations';
        return httpServices.post(apiEndpoint,{project_id : projectId})
            .then(response => {
                if (response.data) {
                    if (response.data.permission) {
                        this.setState({
                            projectLocations: response.data.project_locations,
                        });
                    }
                    else {
                        this.setState({
                            showLoader : false,
                            dataLoaded: true
                        });
                    }
                }
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
    }
    getListProjectResources = (projectId, id) => {
        let apiEndpoint = 'api/project/listProjectResources';
        return httpServices.post(apiEndpoint, {'project_id' : projectId, 'resource_id' : id, 'employmentStatus': 0, 'resourceName':0, 'laborCategory':0, 'gsaLaborCategory':0, 'contractVehicle':0, 'actionType': this.props.Type })
            .then(response => {
                if (response.data.permission) {                  
                    
                        this.setState({
                            projectResources : response.data.project_resources,
                            contractVehicles : response.data.contract_vehicles,
                            otherPermissions : response.data.otherPermissions,
                            users : response.data.users
                            });                    
                }               
            })
             .catch(function(error) {
                console.log("Error: "+error);
            });
    }
    getProjectLabels = (projectId) => {
        let apiEndpoint = 'api/project/listProjectLabels';
        return httpServices.post(apiEndpoint, { 'project_id': projectId })
            .then(response => {
                if (response.data.permission) {
                    this.setState({
                        projectLabels: response.data.labels,
                    });
                }
                else {
                    this.setState({
                        showLoader: false,
                        dataLoaded: true,
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }
    getReportReviewers = (projectId) => {
		let apiEndpoint = "api/project/getReportReviewers";
		return httpServices
			.post(apiEndpoint, { project_id: projectId })
			.then((response) => {
				if (response.data) {
					if (response.data.permission) {
						this.setState({
							showLoader: false,
							permission: response.data.permission,
							editPermission: response.data.edit_permission,
							dataLoaded: true,
							reportReviewers: response.data.project_reviewers,
							usersList: response.data.users_list,
							reports: response.data.reports,
							selectedReport:
								response.data.reports && response.data.reports.id
								? response.data.reports.id
								: "",
							showReportReviewers: !!response.data.reports,
						});
					} else {
						this.setState({
							showLoader: false,
							dataLoaded: true,
						});
					}
				}
			})
			.catch(function (error) {
				console.log("Error: " + error);
			});
	};
    getProjectFormInputs =() => {
        let apiEndpoint = 'api/project/add';
        return httpServices.get(apiEndpoint)
            .then(response => {
                if (response.data.permission) {
                    let formValues = this.state.formValues;
                    formValues.sent_notification = true;
                    if (response.data.default_start_date && !(this.props.Parent && this.props.Parent > 0)) {
                        formValues.startDate = response.data.default_start_date;
                    }
                    this.setState({
                        formInputs : response.data,
                        permission : response.data.permission, 
                        formValues : formValues,
                    }, function(){
                        this.clientChange();
                    });
                } else {
                    this.setState({
                        permission : false,
                        permissionErrMsg : response.data.perm_err_msg,
                    });
                } 
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    };
    handleOnChange = (evt, value) => {
        const field = evt.target.name;
        const ff = this.state.formValues;
        if (evt.target.type && evt.target.type === 'checkbox') {
	    if(field == 'timesheet_location' && !evt.target.checked) {
		ff['lcr_required'] = false;
		ff[field] = evt.target.checked;
	    }
	    else {
                ff[field] = evt.target.checked;
	    }
        } else {
            ff[field] = evt.target.value;
        }
        this.setState({
            formValues: ff
        }, function () {
            if (field === 'client') {
                this.clientChange();
            }
            if (field === 'projectStatus') {
                this.statusChange();
            }
        });
    }
    handleDateChange = (date, name) => {
        let formValues = this.state.formValues;
        formValues[name] = date;
        this.setState({
            formValues: formValues,
        });
    };
    setActiveStep (step) {
        this.setState({
            activeStep : step
        });
    }
    clientChange = () => {
        let selectedClient = this.state.formValues.client;
        let selectedProject = this.state.formValues.projectId; 
        let apiEndpoint = 'api/project/getprojects';
        if ((selectedClient || this.props.Parent)) {
            return httpServices.post(apiEndpoint, {client_id : selectedClient, project_id : selectedProject})
                .then(response => {
                    if (response.data) {
                        let formInputs = this.state.formInputs;
                        formInputs.parentProjects = response.data.projects;
                        let formValues = this.state.formValues;
                        let parentProject = this.state.formValues.projectParent;
                        let showInheritResources = this.state.showInheritResources;
                        let showInheritReviewers = this.state.showInheritReviewers;
                        if (this.props.EditId) {
                            if(parentProject === 0 || parentProject === null){
                                showInheritResources = false;
                                showInheritReviewers = false; 
                                formValues.inheritReviewers = false;
                                formValues.inheritResource = false;
                            }
                            else{
                                showInheritResources = true;
                                showInheritReviewers = true; 
                            }
                        }
                        this.setState({
                            formValues : formValues,
                            formInputs : formInputs,
                            showInheritResources : showInheritResources,
                            showInheritReviewers : showInheritReviewers
                        });
                    } 
                })
                .catch(function (error) {
                    console.log("Error: " + error);
                });
        }
    }
    handleTreeChange = (evt, cNode, sNodes, action) => {
        let project = 0;
        let formValues = this.state.formValues;
        let showInheritResources = true;
        if (sNodes.length < 1) {
            project = 0;
            formValues['inheritResource'] = false;
            showInheritResources = false;
        }
        else if (cNode.project_id) {
            project = cNode.project_id;
        }
        formValues['projectParent'] = project;
        this.setState({ formValues : formValues, showInheritResources : showInheritResources }, function() {
            if (!(this.props.EditId && this.props.EditId > 0)) {
             this.parentChange();
            }
        });
    }
    parentChange = () => {
        let parentProject = this.state.formValues.projectParent;
        let apiEndpoint = 'api/project/getprojectById';
        return httpServices.post(apiEndpoint, {project_id : parentProject})
            .then(response => {
                if (response.data) {
                    let formValues = this.state.formValues;
                    formValues.projectManager = response.data.project.project_manager;
                    formValues.payType = response.data.project.project_paytype;
                    formValues.startDate = response.data.project.project_sdate;
                    formValues.endDate = response.data.project.project_edate;
                    if (this.props.Parent && this.props.Parent > 0) {
                        formValues.client = response.data.project.project_client ? response.data.project.project_client : 0;
                        formValues.reqLabourCategory = (typeof response.data.project.labor_category !== 'undefined' && response.data.project.labor_category) ? parseInt(response.data.project.labor_category) : 0;
                        formValues.offsite = (typeof response.data.project.offsite !== 'undefined' && response.data.project.offsite) ? parseInt(response.data.project.offsite) : false;
                        formValues.chargeCode = response.data.project.project_code ? response.data.project.project_code : '';
                    }
                    let showInheritResources = true;
                    let showInheritReviewers = false;
                    if(parseInt(parentProject) !== 0){
                        showInheritResources = true;
                        showInheritReviewers = true;
                    }
                    else{
                        showInheritResources = false;
                        showInheritReviewers = false;
                        formValues.inheritReviewers = false;
                        formValues['inheritResource'] = false;
                        formValues.inheritResource = false;
                    }
                    this.setState({
                        formValues : formValues,
                        parentSdate : response.data.project.project_sdate,
                        parentEdate : response.data.project.project_edate,
                        showInheritResources : showInheritResources,
                        showInheritReviewers : showInheritReviewers,
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }
    save = () => {
        let valid = this.validateFormData();
        if (valid) {                
                this.setState({ buttonLoader : true});
                this.createProject();               
            
        }
    }
    // Common validation function for project add/edit
    validateFormData = () => {
        this.filterProjectResources();
        let errors = {};
        let formValues = this.state.formValues;
        let valid = true;
        if (!formValues.name || formValues.name === 'undefined' || formValues.name.trim() === '') {
            errors['name'] = 'Project Name cannot be empty';
            valid = false;
        }
        if (!formValues.startDate || formValues.startDate === 'undefined' || formValues.startDate.trim() === 'Invalid date') {
            errors['startDate'] = 'Start Date cannot be empty or invalid';
            valid = false;
        }
        if (!formValues.chargeCode || typeof formValues.chargeCode === 'undefined' || formValues.chargeCode.trim() === '' ) {
            errors['chargeCode'] = 'Project Code cannot be empty';
            valid = false;
        }
        if (!formValues.description || typeof formValues.description === 'undefined' || formValues.description.trim() === '' ) {
            errors['description'] = 'Project Description cannot be empty';
            valid = false;
        }
        if (!formValues.client || formValues.client === '' ) {
            errors['client'] = 'Please select Client';
            valid = false;
        }
        if (!formValues.projectManager || formValues.projectManager === '' ) {
            errors['projectManager'] = 'Please select Project Manager';
            valid = false;
        }
        if (!formValues.startDate || formValues.startDate === '' ) {
            errors['startDate'] = 'Start date cannot be empty';
            valid = false;
        }
        if (!formValues.projectStatus || formValues.projectStatus === '' ) {
            errors['projectStatus'] = 'Please select Status';
            valid = false;
        }
        if (formValues.name.length > 64)
        {
            errors['name'] = 'Project name cannot exceed 64 characters';
            valid = false;
        }
        this.setState({
            errors : errors,
        });
        return valid;
    }
    filterProjectResources = () => {
        const { formValues, actionType, originalResources } = this.state;
        const formStart = new Date(formValues.startDate);
        const formEnd = formValues.endDate ? new Date(formValues.endDate) : null;
        if (actionType === "AddSubProject" || actionType === "Copy") {
            if (!originalResources || originalResources.length === 0) {
                let getProjectId = (actionType === "AddSubProject") ? this.props.Parent : this.props.EditId;
                this.getListProjectResources(getProjectId).then(() => {
                    const projectResources = this.state.projectResources || [];    
                    this.setState({ originalResources: projectResources }, () => {
                        // Apply filtering
                        this.applyResourceFilter(projectResources, formStart, formEnd);
                    });
                });
            } else {
                this.applyResourceFilter(originalResources, formStart, formEnd);
            }
        }
    };    
    applyResourceFilter = (projectResources, formStart, formEnd) => {
        const normalize = (d) => {
            if (!d) return null;
            const date = new Date(d);
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
        };    
        // Normalize the form dates
        const formStartNorm = normalize(formStart);
        const formEndNorm = normalize(formEnd);    
        const filtered = (projectResources || []).filter(resource => {
            // Relieved date check
            const relievedDate =
                resource.user_status === 3 && resource.relieved_date
                    ? normalize(resource.relieved_date)
                    : null;
            if (relievedDate && relievedDate < formStartNorm) return false;
    
            // Resource start and end
            const resStart = normalize(resource.start_date);
            const resEnd = normalize(resource.end_date);    
            // Exclude if no overlap with form date range
            if ((resEnd && resEnd < formStartNorm) || (formEndNorm && resStart > formEndNorm)) {
                return false;
            }    
            return true;
        });    
        this.setState({ projectResources: filtered });
    };    
    createProject = () => {
        this.setState({
            buttonLoader: true,
        });
        let apiEndpoint = 'api/project/add';
        let data = this.state.formValues;
        let newProjectId = null;
        data.selectedLocations = JSON.stringify(this.state.selectedLocations);
        data.selectedTasks = JSON.stringify(this.state.selectedTasks);
        data.selectedResources = JSON.stringify(this.state.selectedResources);
        data.resources = JSON.stringify(this.state.rows);
        data.reviewers = JSON.stringify(this.state.reviewerRows);
        data.selectedLabels = JSON.stringify(this.state.selectedLabels);
        data.selectedReviewers = JSON.stringify(this.state.selectedReviewers);
        data.sourceProject = this.props.EditId;
        data.actionType = this.state.actionType;
        data.sent_notification = typeof this.state.formValues.sent_notification != 'undefined' ? this.state.formValues.sent_notification : true;
        return httpServices.post(apiEndpoint, data)
            .then(response => {
                if (response.data && response.data.success) {
                    newProjectId = response.data.new_project_id;
                    this.setState({
                        buttonLoader: false,
                    });
                    if (this.state.actionType == 'Copy' && newProjectId) {
                        history.push(BASE_PATH+'/projects/view/' + newProjectId);
                    }
                    this.props.UpdateParentOnCopySuccess(true);
                } else {
                    this.setState({
                        errors: response.data.errors,
                        buttonLoader: false
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }
    getProjectDetails = (id) => {
        let apiEndpoint = 'api/project/edit';
        let data = {
            projectId : id,
            action : 'get',
            copyProject : true,
        }
        return httpServices.post(apiEndpoint,data)
            .then(response => {
                if (response.data && response.data.permission && response.data.success) {
                    let formValues = {};
                    let showInheritReviewers = this.state.showInheritReviewers;
                    let showInheritResources = this.state.showInheritResources;
                    if (response.data.project) {
                        let project = response.data.project;
                        formValues.name = project.project_name ? "Copy of "+ project.project_name : '';
                        formValues.projectId = project.project_id ? project.project_id : '';
                        formValues.chargeCode = project.project_code ? project.project_code : '';
                        formValues.description = project.project_description ? project.project_description : '';
                        formValues.client = project.project_client ? project.project_client : 0;
                        formValues.projectManager = project.project_manager ? project.project_manager : 0;
                        formValues.cor = project.cor_id ? project.cor_id : 0;
                        formValues.projectParent = project.project_parent ? project.project_parent : 0;
                        formValues.startDate = project.project_sdate ? project.project_sdate : null;
                        formValues.endDate = project.project_edate ? project.project_edate : null;
                        formValues.prevEndDate = project.project_edate ? project.project_edate : null;
                        formValues.projectStatus = project.project_status ? project.project_status : 0;
                        formValues.prevStatus = project.project_status ? project.project_status : 0;
                        formValues.minTimeInc = (project.minimum_increment || project.minimum_increment === 0)  ? project.minimum_increment : '';
                        formValues.payType = project.project_paytype ? project.project_paytype : 0;
                        formValues.notifyPm = (typeof project.notify_pm !== 'undefined' && project.notify_pm) ? parseInt(project.notify_pm) : false;
                        formValues.offsite = (typeof project.offsite !== 'undefined' && project.offsite) ? parseInt(project.offsite) : false;
                        formValues.lcr_required = (typeof project.lcr_required !== 'undefined' && project.lcr_required) ? parseInt(project.lcr_required) : false;
                        formValues.timesheet_location = (typeof project.timesheet_location !== 'undefined' && project.timesheet_location) ? parseInt(project.timesheet_location) : 0;
			            formValues.prelim_review_flag = (typeof project.prelim_review_flag !== 'undefined' && project.prelim_review_flag) ? parseInt(project.prelim_review_flag) : 0;
                        formValues.approvalMethod = project.wlc_approver ? project.wlc_approver : 'PM';
                        formValues.reqLabourCategory = (typeof project.labor_category !== 'undefined' && project.labor_category) ? parseInt(project.labor_category) : 0;
                        formValues.inheritReviewers = (project.inherit_reviewers !== 'undefined' && project.inherit_reviewers) ? parseInt(project.inherit_reviewers) : 0;
                        formValues.inheritResource = (typeof project.inherit_resource !== 'undefined' && project.inherit_resource) ? parseInt(project.inherit_resource) : 0;
                        formValues.reqClientTimesheet = (project.client_timesheet !== 'undefined' && project.client_timesheet) ? parseInt(project.client_timesheet) : 0;
                        if (project.project_parent && typeof project.project_parent !== 'undefined' && parseInt(project.project_parent) > 0) {
                            showInheritReviewers = true;
                            showInheritResources = true;
                        } else {
                            showInheritReviewers = false;
                            showInheritResources = false;
                        }
                    }
                    let taskCount = 0;
                    if (response.data.task_count && typeof response.data.task_count !== 'undefined') {
                        taskCount = parseInt(response.data.task_count);
                    }
                    let formInputs = response.data;
                    formInputs.parentProjects = response.data.parent_projects;
                    this.setState({
                        formInputs : formInputs,
                        showSubProject : response.data.show_subprojects,
                        formValues : formValues,
                        prParent : response.data.project.project_parent,
                        showInheritReviewers : showInheritReviewers,
                        showInheritResources : showInheritResources,
                        subProjects : response.data.subprojects,
                        permission : true,
                        taskCount : taskCount,
                        showLoader: false,
                        is_contract: response.data.project.is_contract,
                    })
                }
                else if (!response.data.permission) { // Handling permission failure
                    this.setState({
                        showLoader : false,
                        permission : false,
                        permissionErrMsg : response.data.perm_err_msg,
                    });
                } else if (!response.data.success) { // Handling parent project status validation failure
                    this.setState({
                        showLoader : false,
                        permissionErrMsg : response.data.err_msg,
                        permission :  false,
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    };
    // Function for handling project edit status change
    statusChange = () => {
        if (this.state.formValues.projectStatus === 3) {
            if (this.state.showSubProject) {
                //$("#sub_edate_validate").val('0'); // TODO
            }
            this.askEndDate();
        }
    }    
    showTaskEndDateConfirmation = () => {
        if (this.state.taskCount) {
            this.setState({
                popupType : 'active_task_edate_confirmation',
                validationPopupOpen : true,
            });
        } else {
            this.taskEndDateConfirmation(false);
        }
    }
    taskEndDateConfirmation = (status) => {
        let formValues = this.state.formValues;
        if (status) {
            formValues.task_date = 'yes';
        } else {
            formValues.task_date = 'No';
        }
        this.setState({
            formValues : formValues,
        }, function() {
            this.validateDates();
        });
    }
    subProjectStatusChangeConfirmation = (status) => {
        let formValues = this.state.formValues;
        if (status) {
            formValues.change_subproject_status = 'yes';
        } else {
            formValues.change_subproject_status = 'no';
        }
        let currEndDate = this.state.formValues.endDate;
        let prevEndDate = this.state.formValues.prevEndDate;
        this.setState({
            formValues: formValues,
        }, function () {
            if (currEndDate !== prevEndDate) {
                this.showTaskEndDateConfirmation();
            } else {
                this.validateDates();
            }
        });
    }
    // Project edit specific validate function
    validateDates = () => {
        let id = this.state.formValues.projectId;
        let projectSdate = this.state.formValues.startDate;
        let projectEdate = this.state.formValues.endDate;
        let projectId = this.state.formValues.projectParent;
        let data = {
            project_sdate : projectSdate, 
            project_edate : projectEdate, 
            project_id : projectId, 
            id:id
        };
        // Date validation
        let apiEndpoint = 'api/project/validateprojectdate';
        return httpServices.post(apiEndpoint, data)
            .then(response => {
                if (response.data) {
                    this.setState({
                        validationPopupOpen : false,
                    });
                    let data = response.data;
                    if (data.date_changed) {
                        if (data.flag && typeof data.sub_projects_count !== 'undefined' && parseInt(data.sub_projects_count) === 0){
                            this.updateProject();
                        }
                        else if (data.flag && typeof data.sub_projects_count !== 'undefined' && (parseInt(data.sub_projects_count) !== 0)) {
                            let msg = "Sub Project(s) are not in the span of the Project. Please confirm the dates.";
                            let errors = this.state.errors;
                            this.setState({
                                validationPopupMsg : msg,
                                popupType : 'dialog_confirm_dates',
                                validationPopupOpen : true,
                                errors : errors,
                            });
                        }
                        else if (!data.flag && typeof data.sub_projects_count !== 'undefined' && ( parseInt(data.sub_projects_count) !== 0)) {
                            let msg = "The dates you have entered do not fall in the range between the start and end date of the parent project. Also, Sub Project(s) are not in the span of the Project. Please confirm the dates.";
                            let errors = this.state.errors;
                            this.setState({
                                validationPopupMsg : msg,
                                popupType : 'dialog_confirm_dates',
                                validationPopupOpen : true,
                                errors : errors,
                            });
                        }
                        else if (!data.flag && typeof data.sub_projects_count !== 'undefined' && (parseInt(data.sub_projects_count) === 0)) {
                            let msg = "The dates you have entered do not fall in the range between the start and end date of the parent project. Please confirm.";
                            let errors = this.state.errors;
                            this.setState({
                                validationPopupMsg : msg,
                                popupType : 'dialog_confirm_dates',
                                validationPopupOpen : true,
                                errors : errors,
                            });
                        }
                    }
                    else {
                        this.updateProject();
                    }
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }
    updateProject = () => {
        if (this.state.formValues.inheritResource) {
            let apiEndpoint = 'api/project/validateInheritance';
            let data = this.state.formValues;
            return httpServices.post(apiEndpoint, {project_id : this.state.formValues.projectId})
                .then(response => {
                    this.setState({
                        additionalResources : response.data.additional_resources_array,
                        additionalLcats : response.data.additional_lcats_array,
                    });
                    if (response.data && response.data.success) {
                        this.saveProject();
                    } else {
                        this.setState({
                            buttonLoader : false,
                            validationPopupOpen : true,
                        });
                    }
                })
                .catch(function (error) {
                    console.log("Error: " + error);
                });
        }
        else {
            this.saveProject();
        }        
    }
    snackbarClose = () => {
        this.setState({
            snackbarOpen : false,
        });
    }
    onAddResourceClose = () => {
        this.setState({
            openAddResource : false,
        });

    }
    saveProject = () => {
        this.setState({
            buttonLoader : true,
        });
        let apiEndpoint = 'api/project/edit';
        let data = Object.assign({}, this.state.formValues);
        data.action = 'update';
        if (this.state.subProjects && typeof this.state.subProjects !== 'undefined' && this.state.subProjects.length) {
            data.subprj_enddate = JSON.stringify(this.state.subProjects);
        }
        return httpServices.post(apiEndpoint, data)
            .then(response => {
                if (response.data && response.data.success) {
                    this.props.UpdateParentOnCopySuccess(true);
                }
                else if (response.data.errors) {
                    this.setState({
                        buttonLoader : false,
                        errors : response.data.errors
                    });
                } 
                else {
                    this.setState({
                        buttonLoader : false,
                        postValidationErr : response.data.err_msg,
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    }
    confirmDatesSubmit = () => {
        let confirmSDate = this.state.formValues.confirmStartDate;
        let confirmEDate = this.state.formValues.confirmEndDate;
        let edate = this.state.formValues.endDate;
        if ((typeof confirmSDate === 'undefined' || confirmSDate === '')) {
            let msg = 'Start date is required.';
            this.setState({
                dateConfirmationError : msg,
            });
        }
        else {
            let formValues = this.state.formValues;
            formValues.startDate = confirmSDate;
            formValues.endDate = confirmEDate;

            this.setState({
                validationPopupOpen : false,
                formValues : formValues,
            }, function () {
                 let projectParent = this.props.Parent;
                 if (projectParent && projectParent > 0) {
                     this.createProject();
                 }
                else
                {
                 this.updateProject();
                }
            });
        }
    }
    // Ask end date for all sub projects
    askEndDate = () => {
        this.setState({
            validationPopupOpen : true,
            popupType : 'end_date_confirmation_for_all_subprojects'
        }); 
    }
    validateRowData = () => {
        const { rows, users, formValues } = this.state;
        let rowCount = rows.length;
        let errors = {};
        let valid = true;
        let continueFlag = true;
        if (rowCount == 1) {
            let firstRow = rows[0];
            if (firstRow.selectedOption || firstRow.startDate || firstRow.endDate) {
                continueFlag = true;
            }
            else {
                continueFlag = false;
            }
        }
        if (continueFlag) {
            rows.forEach((row) => {
                errors[row.id] = {};
                if (row.selectedOption === '') {
                    errors[row.id].selectedOption = 'Resource is required';
                    valid = false;
                }
                if (row.startDate === '') {
                    errors[row.id].startDate = 'Start date is required';
                    valid = false;
                }
                if (row.selectedOption && row.startDate) {
                    let user = users.filter(item => item.user_id == row.selectedOption);
                    let minDate = (!user[0]['date_joined'] || formValues.startDate < user[0]['date_joined']) ? formValues.startDate : user[0]['date_joined'];
                    if (row.startDate < minDate) {
                        errors[row.id].startDate = 'Cannot add Resource. Start date cannot be earlier than employee joining date/ project start date';
                        valid = false;
                    }
                    if (row.startDate !== '' && formValues.startDate !== '' && row.startDate < formValues.startDate) {
                        errors[row.id].startDate = 'Start date cannot be less than project start date';
                        valid = false;
                    }
                    if (formValues.endDate !== '' && row.startDate > formValues.endDate) {
                        errors[row.id].startDate = 'Start date cannot be greater than project end date.';
                        valid = false;
                    }
                    if (row.endDate !== '' && formValues.startDate !== '' && row.endDate < formValues.startDate) {
                        errors[row.id].endDate = 'End date cannot be less than project start date';
                        valid = false;
                    }
                    if (row.endDate !== '' && formValues.endDate !== '' && row.endDate > formValues.endDate) {
                        errors[row.id].endDate = 'End date cannot be greater than project end date';
                        valid = false;
                    }
                }
                if ((row.endDate && row.startDate) && row.endDate < row.startDate) {
                    errors[row.id].endDate = 'End date should be greater than start date';
                    valid = false;
                }
            });
        }
        this.setState({ errors: errors });
        return valid;
    }
    handleEndDateConfirmationForClosed = (date, name) => {
        if (name) {
            let subProjects = this.state.subProjects;
            let index = subProjects.findIndex(x => x.project_id === parseInt(name));
            if (index !== -1) {
                let curObj = subProjects[index];
                curObj.project_edate = date;
                subProjects[index] = curObj;
            } 
            this.setState({
                subProjects : subProjects,
            });
        }         
    }        
    render() {
        return (
            <>
            <CustomProgressBar
                loaderOpen={this.state.showLoader}
            />
            <CreateProjectWizardComponent
                FormInputs = {this.state.formInputs}
                HandleOnChange = {this.handleOnChange}
                FormValues = {this.state.formValues}
                HandleTreeChange = {this.handleTreeChange}
                ShowInheritResources = {this.state.showInheritResources}
                ShowInheritReviewers = {this.state.showInheritReviewers}
                Errors = {this.state.errors}
                Save = {this.save}
                Open = {this.state.open}
                OnClose = {this.onClose}
                OnAddResourceClose = {this.onAddResourceClose}
                Title = {this.props.Title}               
                StatusChange = {this.statusChange}
                ValidationPopupOpen = {this.state.validationPopupOpen}
                ValidationPopupMsg = {this.state.validationPopupMsg}
                PopupType = {this.state.popupType}
                ConfirmationClose = {this.confirmationClose}
                ShowTaskEndDateConfirmation = {this.showTaskEndDateConfirmation}
                ValidateDates = {this.validateDates}
                ConfirmDatesSubmit = {this.confirmDatesSubmit}
                SubProjects = {this.state.subProjects}
                TaskEndDateConfirmation = {this.taskEndDateConfirmation}
                ProjectParent = {this.props.Parent}
                Permission = {this.state.permission}
                PermissionErrMsg = {this.state.permissionErrMsg}
                PostValidationErr = {this.state.postValidationErr}
                HandleEndDateConfirmationForClosed = {this.handleEndDateConfirmationForClosed}
                DateConfirmationError = {this.state.dateConfirmationError}
                ButtonLoader={this.state.buttonLoader}
                handleDateChange = {this.handleDateChange}
                NameFormat = {this.state.nameFormat}
                SnackbarOpen = {this.state.snackbarOpen}
                SnackbarMsg = {this.state.snackbarMsg}
                SnackbarVarient = {this.state.snackbarVarient}
                SnackbarClose = {this.snackbarClose}
                AdditionalResources = {this.state.additionalResources}
                AdditionalLcats = {this.state.additionalLcats}
                SaveProject = {this.saveProject}
                SubProjectStatusChangeConfirmation = {this.subProjectStatusChangeConfirmation}
                ActiveStep = {this.state.activeStep}
                SetActiveStep = {this.setActiveStep}
                ProjectLocations = {this.state.projectLocations}
                ProjectResources = {this.state.projectResources}
                OtherPermissions = {this.state.otherPermissions}
                Tasks = {this.state.tasks}
                OnTaskSelectionChange = {this.onTaskSelectionChange}
                SelectedTasks = {this.state.selectedTasks}
                SelectAllTasks = {this.state.selectAllTasks}
                selectedRows={this.state.selectedRows}
                handleSelectedRows={this.handleSelectedRows}
                HandleCheckboxChange = {this.handleCheckboxChange}
                SelectedResources = {this.state.selectedResources}
                SelectAllResources = {this.state.selectAllResources}
                SelectedLocations = {this.state.selectedLocations}
                SelectAllLocations = {this.state.selectAllLocations}
                ValidateFormData = {this.validateFormData}
                ValidateRowData = {this.validateRowData}
                ContractVehicles = {this.state.contractVehicles}
                ProjectLabels = {this.state.projectLabels}
                ReportReviewers = {this.state.reportReviewers}
                ShowReportReviewersTab = {this.state.showReportReviewers}
                SelectedLabels = {this.state.selectedLabels}
                SelectedReviewers = {this.state.selectedReviewers}
                SelectAllLabels = {this.state.selectAllLabels}
                SelectAllReviewers = {this.state.selectAllReviewers}
                IsContract = {this.state.is_contract}
                ActionType = {this.state.actionType}
                OpenAddResource = {this.state.openAddResource}
                OnAddResourceClick = {this.onAddResourceClick}
                OnAddReviewerClick = {this.onAddReviewerClick}
                Users = {this.state.users}
                HandleResourceChange = {this.handleResourceChange}
                ResourceRows = {this.state.rows}
                ReviewerRows = {this.state.reviewerRows}
                DeleteRow = {this.deleteRow}
                ErrorRow = {this.state.errorRow}
                DeleteReviewerRow = {this.deleteReviewerRow}
                HandleReviewerChange = {this.handleReviewerChange}
                Reports = {this.state.reports}
                SelectedReport = {this.state.selectedReport}
            />
            </>
        )
    }
}
